
import InformationBarUtils from '../../../commons/header/information-bar-header-utils';
import { ActionAPI, FieldAPI, FormAPI, ModalProps, ModalService, RadioGroupAPI, SelectableItem, ToastService } from '@philips-internal/oswald-ui-components';
import { AdmittedInjuriesRadioGroup, WoundsOptionsId, WoundsRadioGroupId,  } from '../wounds-radio-group-data/wounds-radio-group-expressions';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants/lib';
import { WoundsDressingsTabListContext } from '../../service/wounds-dressing-tab-list-service';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { Value } from '@philips-internal/oswald-ui-core';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';
import { WoundsDressingContext } from '../../wounds-dressing-service';

import { Inject } from '@odinjs/odin';
import moment from 'moment';

import { WoundsDressingTabType, WoundsRequest, WoundsResponse } from '../../types/wounds-dressings-types';
import { FragmentNames, WoundsViewerAliases } from '../../../../codegen';
import { BooleanUtils } from '../../../../utils/boolean-utils';
import { Endpoint } from '../../../../constants/endpoints';
import { FULL_LOCALE_DATE } from '../../../../constants/date-utils';
import { ApplicationRoute } from '../../../../constants/routes';
import BaseController from '../../../BaseController';
import { HealthProfessionalUser } from '../../../../app/authentication';

@Controller({ component: WoundsViewerAliases.LAYOUT_WOUNDS_VIEWER, fragment: FragmentNames.WOUNDS_VIEWER })
class WoundsViewerController extends BaseController {

  @Inject(WoundsViewerAliases.FORM_WOUNDS_VIEWER)
  private formWoundsViewerApi!: FormAPI;

  @Inject(WoundsViewerAliases.FIELD_SEQUENCE_LOCATION)
  private fieldLocationApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_CLINIC)
  private fieldClinicApi!: FieldAPI

  @Inject(WoundsViewerAliases.FIELD_DIAGNOSIS)
  private fieldDiagnosisApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_INDETERMINATE_START)
  private fieldIndeterminateStartApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_MEDICAL)
  private fieldMedicalApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_OBSERVATION)
  private fieldObservationApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_SEQUENCE_IDENTIFICATION)
  private fieldSequenceIdentificationApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_SEQUENCE_WOUND_CLASSIF)
  private fieldWoundClassificationApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_SEQUENCE_WOUND_TYPE)
  private fieldWoundTypeApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_SERVICE_SECTOR)
  private fieldSectorApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_START_DATE_WOUND)
  private fieldStartDateWoundApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_ADMITTED_INJURED)
  private fieldAdmittedInjuredApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_REASON_END_TREATMENT)
  private fieldReasonEndTreatmentApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_WOUND_FORMAT)
  private fieldWoundFormatApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_ALLERGIES)
  private fieldAllergiesAPI!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_PAIN_SITE)
  private fieldPainSiteAPI!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_PRESENCE_PAIN)
  private fieldPresencePainApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_ALLERGY_MEDICATIONS)
  private fieldAllergyMedicationsApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_WOUND_HISTORY)
  private fieldWoundHistoryApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_WOUND_DAY)
  private fieldWoundDayApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_WOUND_MONTH)
  private fieldWoundMonthApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_WOUND_YEAR)
  private fieldWoundYearApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_WHO_TREATED)
  private fieldWhoTreatedApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_WHAT_USED)
  private fieldWhatUsedApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_RELEASE_DATE)
  private fieldReleaseDateApi!: FieldAPI;

  @Inject(WoundsViewerAliases.FIELD_RELEASE_USER)
  private fieldReleaseUserAPI!: FieldAPI;

  @Inject(WoundsViewerAliases.ACTION_INACTIVATE_WOUND)
  private actionInactivateAPI!: ActionAPI;

  @Inject(WoundsViewerAliases.ACTION_NEW_WOUND)
  private actionNewAPI!: ActionAPI;

  @Inject(WoundsViewerAliases.ACTION_END_TREATMENT)
  private actionEndTreatmentAPI!: ActionAPI;

  @Inject(WoundsViewerAliases.ACTION_UNDO_END_TREATMENT)
  private actionUndoEndAPI!: ActionAPI;

  private openModalInactivation(): void {
    const { woundId } = this.historyService.getCurrentRouteParams() as Record<string, Value>;
    const modalProperties: ModalProps = {
      closeable: false,
      closeByDocument: false,
      closeByEscape: false,
      focusOnOpen: false,
      fragment: 'wounds-dressings-inactivate',
      id: 'wounds-dressings-inactivate',
      onCancel: () => { },
      onSubmit: () => { },
      title: 'title.disable-record',
      uuid: generateUUID(),
    };

    modalProperties.contextData = {
      woundId
    } as Record<string, Value>;

    ModalService.openDefault(modalProperties);
  }

  private openModalEndTreatment(): void {
    const { woundId } = this.historyService.getCurrentRouteParams() as Record<string, Value>;
    const modalProperties: ModalProps = {
      closeable: false,
      closeByDocument: false,
      closeByEscape: false,
      focusOnOpen: false,
      fragment: 'wounds-end-treatment',
      id: 'wounds-end-treatment',
      onCancel: () => { },
      onSubmit: () => { },
      title: 'label.end-treatment',
      uuid: generateUUID(),
    };

    modalProperties.contextData = {
      woundId
    } as Record<string, Value>;

    ModalService.openDefault(modalProperties);
  }

  private undoEndTreatment(): void {
    const { woundId } = this.historyService.getCurrentRouteParams();
    this.formWoundsViewerApi.setLoading(true);

    const body = {
      woundId
    } as Record<string, Value>;

    HttpService.put(Endpoint.UNDO_END_TREATMENT_WOUND, undefined, {body})
      .then(() => {
        applicationContext.popNavigationItem();
        this.showToast('label.operation-done', ToastLevel.SUCCESS);
      }).catch((err) => {
        err?.body && this.showToast(err?.body, ToastLevel.ERROR);
      }).finally(() => this.formWoundsViewerApi.setLoading(false));
  }

  @OnMount({target: WoundsViewerAliases.LAYOUT_WOUNDS_VIEWER})
  handleMountLayout(): void {
    const { encounterId, patientId, woundId } = this.historyService.getCurrentRouteParams();
    InformationBarUtils.collapsedBar = true;
    this.context.set({ encounterId, patientId, woundId });
    WoundsDressingsTabListContext.currentTab = WoundsDressingTabType.WOUNDS;
  }

  @OnMount({target: WoundsViewerAliases.FORM_WOUNDS_VIEWER })
  handleMountForm(): void {
    this.formWoundsViewerApi.setLoading(true);
    this.handleFetchWounds();
  }

  @OnMount({target: WoundsViewerAliases.RADIO_GROUP_ADMITTED_INJURED})
  handleMountRadioGroup(event: MountEvent): void {
    const radioGroup = event.target as RadioGroupAPI;
    this.setRadioGroupValues(WoundsRadioGroupId.GROUP_ID_ADMITTED_INJURED, radioGroup)
  }

  @OnClick(WoundsViewerAliases.ACTION_INACTIVATE_WOUND)
  handleClickInactivate(): void {
    this.openModalInactivation();
  }

  @OnClick(WoundsViewerAliases.ACTION_NEW_WOUND)
  handleClickNew(): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    applicationContext.redirect(ApplicationRoute.WOUNDS_CREATE, {
      encounterId,
      patientId,
    });
  }

  @OnClick(WoundsViewerAliases.ACTION_END_TREATMENT)
  handleClickEndTreatment(): void {
    this.openModalEndTreatment();
  }

  @OnClick(WoundsViewerAliases.ACTION_UNDO_END_TREATMENT)
  handleClickUndoEndTreatment(): void {
    this.undoEndTreatment();
  }

  private setRadioGroupValues(expressionId: number, radioGroup: RadioGroupAPI): void {
    const { encounterId, patientId } = this.historyService.getCurrentRouteParams();
    HttpService.get(Endpoint.GET_PAIN_SCALE_DATA, { encounterId, expressionId, patientId })
      .then(response => {
        const responseBody = response.body as SelectableItem[];
        radioGroup.setData(responseBody);
        const { admittedInjury } = this.context.get('wounds');
        switch (admittedInjury) {
          case WoundsOptionsId.COMMUNITY:
            return radioGroup.setValue(responseBody[AdmittedInjuriesRadioGroup.COMMUNITY])
          case WoundsOptionsId.HOSPITAL_CLINIC:
            return radioGroup.setValue(responseBody[AdmittedInjuriesRadioGroup.HOSPITAL_CLINIC])
          case WoundsOptionsId.SECTOR:
            return radioGroup.setValue(responseBody[AdmittedInjuriesRadioGroup.SECTOR])
        }
      }).catch((error) => {
        error?.body?.errorMessage && this.showToast(error?.body, ToastLevel.ERROR)
      });
  }

  private handleData(record: WoundsResponse): WoundsRequest {
    const previousHistory     = BooleanUtils.isTrueValue(record.previousHistory);
    const reportedPain        = BooleanUtils.isTrueValue(record.reportedPain);
    const unknownStart        = BooleanUtils.isTrueValue(record.unknownStart);
    const medicineAllergy     = BooleanUtils.isTrueValue(record.medicineAllergy);

    const classification      = record.classification?.description as string;
    const clinic              = record.clinic?.description as string;
    const complement          = record.complement?.description as string;
    const location            = record.location?.description as string;
    const professional        = record.professional?.description as string;
    const sector              = record.sector?.description as string;
    const woundShape          = record.woundShape?.description as string;
    const woundType           = record.woundType?.description;
    const admittedInjury      = record.admittedInjury as string;
    const reasonEndTreatment  = record.reasonEndTreatment?.description as string;

    const startDate           = moment(record.startDate).local().format(FULL_LOCALE_DATE);
    const releaseDate         = moment(record.releaseDate).local().format(FULL_LOCALE_DATE);

    return {
      ...record,
      admittedInjury,
      classification,
      clinic,
      complement,
      location,
      medicineAllergy,
      previousHistory,
      professional,
      reasonEndTreatment,
      releaseDate,
      reportedPain,
      sector,
      startDate,
      unknownStart,
      woundShape,
      woundType,
    }
  }

  private displayEndTreatment(): void {
    const allowInfo = InformationBarUtils.allowInfo && WoundsDressingContext.getAllowEdit();

    if (!allowInfo) {
      this.actionUndoEndAPI.setEnabled(false);
      this.actionEndTreatmentAPI.setEnabled(false);
    } else {
      const wounds = this.context.get('wounds') as WoundsRequest;
      if (wounds.releaseDate && wounds.reasonEndTreatment) {
        this.actionUndoEndAPI.setEnabled(true);
        return;
      }
      this.actionEndTreatmentAPI.setEnabled(true);
    }
  }

  private handleFetchWounds(): Promise<void> {
    const woundId = this.context.get('woundId');
    const allowInfo = InformationBarUtils.allowInfo && WoundsDressingContext.getAllowEdit();

    return HttpService.get(Endpoint.WOUND, {
      sequenceNumberWound: woundId
    })
      .then(response => {
        const res = response.body as WoundsResponse;
        const user = foundationContext.getUser() as HealthProfessionalUser;
        const treatedData = this.handleData(res);
        const showInactivate = res.professional.id === user.physicalPersonId && Boolean(res.showInactivate) && allowInfo;

        this.context.set({ wounds: treatedData })
        this.formWoundsViewerApi.setData({...treatedData});
        this.handleVisibleFields(res);
        this.actionInactivateAPI.setEnabled(showInactivate);
      })
      .catch((error) => this.showToast(error?.body.errorMessage, ToastLevel.ERROR))
      .finally(() => {
        this.formWoundsViewerApi.setLoading(false);
        this.actionNewAPI.setEnabled(allowInfo);
        this.displayEndTreatment();
      });
  }

  private handleVisibleFields(record: WoundsResponse): void{
    this.fieldMedicalApi.setVisible(BooleanUtils.isNotNull(record.professional?.id));
    this.fieldClinicApi.setVisible(BooleanUtils.isNotNull(record.clinic?.id));
    this.fieldWoundDayApi.setVisible(BooleanUtils.isNotNull(record.woundDay));
    this.fieldWhatUsedApi.setVisible(BooleanUtils.isNotNull(record.whatUsed));
    this.fieldWoundYearApi.setVisible(BooleanUtils.isNotNull(record.woundYear));
    this.fieldWhoTreatedApi.setVisible(BooleanUtils.isNotNull(record.whoTreated));
    this.fieldSectorApi.setVisible(BooleanUtils.isNotNull(record.sector?.id));
    this.fieldWoundMonthApi.setVisible(BooleanUtils.isNotNull(record.woundMonth));
    this.fieldDiagnosisApi.setVisible(BooleanUtils.isNotNull(record.diagnosis));
    this.fieldReleaseDateApi.setVisible(BooleanUtils.isNotNull(record.releaseDate));
    this.fieldObservationApi.setVisible(BooleanUtils.isNotNull(record.observation));
    this.fieldWoundFormatApi.setVisible(BooleanUtils.isNotNull(record.woundShape?.valueDomain));
    this.fieldPresencePainApi.setVisible(BooleanUtils.isNotNull(record.reportedPain));
    this.fieldWoundHistoryApi.setVisible(BooleanUtils.isNotNull(record.previousHistory));
    this.fieldWoundTypeApi.setVisible(BooleanUtils.isNotNull(record.woundType?.id));
    this.fieldLocationApi.setVisible(BooleanUtils.isNotNull(record.location?.id));
    this.fieldStartDateWoundApi.setVisible(BooleanUtils.isNotNull(record.startDate) && !BooleanUtils.isTrueValue(record.unknownStart));
    this.fieldReleaseUserAPI.setVisible(BooleanUtils.isNotNull(record.releaseUsername));
    this.fieldAdmittedInjuredApi.setVisible(BooleanUtils.isNotNull(record.admittedInjury as unknown as string));
    this.fieldAllergyMedicationsApi.setVisible(BooleanUtils.isNotNull(record.medicineAllergy));
    this.fieldIndeterminateStartApi.setVisible(BooleanUtils.isNotNull(record.unknownStart));
    this.fieldReasonEndTreatmentApi.setVisible(BooleanUtils.isNotNull(record.reasonEndTreatment?.valueDomain));
    this.fieldWoundClassificationApi.setVisible(BooleanUtils.isNotNull(record.classification?.id));
    this.fieldSequenceIdentificationApi.setVisible(BooleanUtils.isNotNull(record.complement?.id));
    this.fieldPainSiteAPI.setVisible(BooleanUtils.isNotNull(record.painSite));
    this.fieldAllergiesAPI.setVisible(BooleanUtils.isNotNull(record.allergies));
  }

  private showToast(message: string, level: ToastLevel): void {
    ToastService.open({
      dismissible: true,
      highlight: false,
      id: 'wounds-viewer',
      level,
      message,
      placement: Placement.BOTTOM,
      showIcon: true,
      timeout: 5000,
      type: ToastType.BANNER,
    })
  }

}
export default WoundsViewerController;
